module.exports = __webpack_public_path__ + "img/banner-39.jpg";